import React from 'react';

function ReportHeader({ savedCollegesCount, onScrollToSaved }) {
  return (
    <div className="report-narrow-header">
      <div className="header-left">
        <img
          src={`${process.env.PUBLIC_URL}/PrepScholar-Logo-Colored.png`}
          alt="PrepScholar Logo"
          className="header-logo-small"
        />
        <span className="app-name">My College Chances</span>
      </div>

      <div className="header-right">
        <button
          className="header-link"
          onClick={onScrollToSaved}
        >
          <span className="header-link-text">My Saved Colleges</span>
          <span className="header-link-text-mobile">Saved</span>
          {savedCollegesCount > 0 && <span className="saved-count">{savedCollegesCount}</span>}
        </button>
        <a
          href="tel:+18668115177"
          className="header-cta"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
}

export default ReportHeader;